export class RoutePath {
  static readonly Agreement = '/agreement';
  static readonly PostDownload = '/post-download';
}
